import type { TOC } from '@ember/component/template-only';
import { LinkTo } from '@ember/routing';
import ThemeSelector from './theme-selector';
import Icon from './icon';
import UserIcon from '~icons/lucide/user';
import HeartIcon from '~icons/lucide/heart';
import VideoIcon from '~icons/lucide/video';
import MapPinIcon from '~icons/lucide/map-pin';
import HomeIcon from '~icons/lucide/home';
import CompassIcon from '~icons/lucide/compass';

interface NavLink {
  route: string;
  label: string;
  icon: typeof HomeIcon;
}

interface NavbarSignature {
  Element: HTMLDivElement;
}

const NAV_LINKS: NavLink[] = [
  { route: 'index', label: 'Home', icon: HomeIcon },
  { route: 'explore', label: 'Explore', icon: CompassIcon },
  { route: 'items', label: 'Items', icon: HeartIcon },
  { route: 'sources', label: 'Sources', icon: VideoIcon },
  { route: 'places', label: 'Places', icon: MapPinIcon },
];

const Navbar: TOC<NavbarSignature> = <template>
  <div
    class="navbar bg-base-100 border-base-300 sticky top-0 z-50 hidden border-b pt-[env(safe-area-inset-top)] lg:flex"
    ...attributes
  >
    <div class="navbar-start">
      <LinkTo @route="index" class="btn btn-ghost text-xl">
        Favoris
      </LinkTo>
    </div>

    <div class="navbar-center">
      <ul class="menu menu-horizontal gap-1 px-1">
        {{#each NAV_LINKS as |link|}}
          <li>
            <LinkTo
              @route={{link.route}}
              @activeClass="menu-active"
              class="gap-1"
            >
              <Icon @icon={{link.icon}} class="h-4 w-4" />
              {{link.label}}
            </LinkTo>
          </li>
        {{/each}}
      </ul>
    </div>

    <div class="navbar-end gap-2">
      <ThemeSelector />
      <LinkTo
        @route="my-account"
        class="btn btn-ghost btn-circle"
        aria-label="My account"
      >
        <Icon @icon={{UserIcon}} class="h-5 w-5" />
      </LinkTo>
    </div>
  </div>
</template>;

export default Navbar;
